import { SmokingIcon } from './SmokingIcon';

/**
 * author: Google
 * id 20A9F2BB-C53E-410E-A433-4CEE2305AD49
 * name smoking
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/smoking.svg
 * tags
 * - Automotive 
 */
export const SmokingAreaIcon = SmokingIcon;
export default SmokingAreaIcon